// extracted by mini-css-extract-plugin
export default {"wrapper":"default_wrapper__lgsvY","icon":"default_icon__LSn4p","title":"default_title__bpY1u"};